import AjaxBlocking from "./AjaxBlocking";

export default class newsletter {
    constructor() {
        this.init();
    }

    init() {
        const newsletterButton = document.getElementById("js-newsletter-from");
        if (newsletterButton) {
            newsletterButton.addEventListener("submit", (e) => {
                e.preventDefault();
                const name = e.target.querySelector(
                    ".footer-newsletter__form-input--name"
                ).value;

                if (name) return;

                const email = e.target.querySelector(
                    ".footer-newsletter__form-input"
                ).value;
                this.addToNewslleter(email);
            });
        }
    }

    addToNewslleter(email) {
        const self = this;
        const respContainer = document.getElementById("js-newsletter-message");

        self.blockForAjax();

        fetch(window.global.ajax_url + "?action=AddEmailToNewsletter", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                email: email,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                console.log(data);
                console.log(data.success);
                if (data.success) {
                    respContainer.innerHTML = `<p style="color: #63908b;">${data.data}</p>`;

                    // if (fbq && typeof fbq === "function") {
                    //     fbq("track", "Contact", {
                    //         value: email,
                    //     });
                    // }
                } else {
                    respContainer.innerHTML = `<p style="color: #ed6b69;">${data.data}</p>`;
                }

                self.unblockForAjax();
            })
            .catch((err) => {
                console.log(err);
                self.unblockForAjax();
            });
    }

    blockForAjax() {
        const newsletterButton = document.getElementById("js-newsletter-from");

        if (!newsletterButton) return;

        const myBlock = new AjaxBlocking();
        myBlock.blockOnAjax(newsletterButton);
    }

    unblockForAjax() {
        const newsletterButton = document.getElementById("js-newsletter-from");

        if (!newsletterButton) return;

        const myBlock = new AjaxBlocking();
        myBlock.unblockOnAjax(newsletterButton);
    }
}
